// Generates React Router <Route> elements from the navRegistry.
// Rule §14.1: all routes come from the registry, not hand-coded in App.tsx.

import { createElement } from 'react'
import { Route, Navigate } from 'react-router-dom'
import { groups, APP_BASE } from './navRegistry'
import { visibleGroups, isItemHidden } from '@synvya/portal-ui/visibility'
import type { NavGroup, NavItem } from '@synvya/portal-ui/types'

function relativeFrom(absolute: string, base: string): string {
  if (absolute === base) return ''
  return absolute.slice(base.length + 1)
}

function isReachable(item: NavItem): boolean {
  return !isItemHidden(item) && item.element != null
}

function buildGroupRoute(group: NavGroup): JSX.Element {
  const reachable = group.items.filter(isReachable)
  const indexItem = reachable.find((i) => i.to === group.basePath)
  const childItems = reachable.filter((i) => i.to !== group.basePath)

  let indexRoute: JSX.Element | null = null
  if (indexItem?.element) {
    indexRoute = (
      <Route key="__index" index element={createElement(indexItem.element)} />
    )
  } else if (childItems.length > 0) {
    const first = childItems[0]
    const target = relativeFrom(first.to, group.basePath)
    indexRoute = (
      <Route
        key="__index"
        index
        element={<Navigate to={target} replace />}
      />
    )
  }

  const subRoutes = childItems.map((item) => (
    <Route
      key={item.to}
      path={relativeFrom(item.to, group.basePath)}
      element={createElement(item.element!)}
    />
  ))

  return (
    <Route
      key={group.id}
      path={relativeFrom(group.basePath, APP_BASE)}
    >
      {indexRoute}
      {subRoutes}
    </Route>
  )
}

export function groupRoutes(): JSX.Element[] {
  return visibleGroups(groups).map(buildGroupRoute)
}
